import * as React from "react";

import { skipToken as reactQuerySkipToken } from "@tanstack/react-query";
import { useCurrentWorkspaceId } from "@v2/contexts/WorkspaceDashboardContext";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { analyticsRouter } from "@v2/trpc/routes/analytics";
import { subscriptionRouter } from "@v2/trpc/routes/subscription";

const useAnalyticsStatus = () => {
  const workspaceId = useCurrentWorkspaceId() ?? undefined;
  const projectId = useCurrentProjectId();

  const { data: isEnabled, isLoading: isLoadingEnableCheck } =
    analyticsRouter.isEnabled.useQuery(
      workspaceId || projectId
        ? { workspaceId, projectId }
        : reactQuerySkipToken,
    );

  const { data: subscription, isLoading: isLoadingSubscription } =
    subscriptionRouter.getActiveSubscription.useQuery(
      workspaceId ? { workspaceId, projectId } : reactQuerySkipToken,
    );

  const isCurrentlyPaying = Boolean(
    subscription && subscription.billingTier !== "free",
  );

  const isLoading = isLoadingEnableCheck || isLoadingSubscription;

  const dataDisplayType = (() => {
    if (isEnabled && !isCurrentlyPaying) {
      return "partialData";
    } else if (!isEnabled && isCurrentlyPaying) {
      return "blurFullScreenRequireShopifyConnect";
    } else if (!isEnabled && !isCurrentlyPaying) {
      return "blurFullScreenRequireUpgrade";
    } else {
      return "normal";
    }
  })();

  return {
    isEnabled,
    isCurrentlyPaying,
    isLoading,
    dataDisplayType,
    shouldBlurFullScreen:
      dataDisplayType === "blurFullScreenRequireShopifyConnect" ||
      dataDisplayType === "blurFullScreenRequireUpgrade",
  };
};

export default useAnalyticsStatus;
